var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDown)?_c('i',{staticClass:"download_center",class:_vm.isStore ? 'store_download_center' : '',style:({ top: _vm.top }),on:{"click":_vm.go_download}},[(_vm.downloadNum)?_c('span',{staticClass:"download_num"}):_vm._e(),_vm._v(" "),(_vm.isStore)?_c('span',{staticClass:"text"},[_vm._v("下载中心")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }